import type { ModalCopy } from "@circle-react-shared/TrixEditor/InlineModalSelector/ModalCopy";
import { Button } from "@circleco/compass/components/Button";
import { Divider } from "@circleco/compass/components/Divider";
import { TextInput } from "@circleco/compass/components/TextInput";
import type { FormEvent } from "react";
import { useState } from "react";

import { t } from "@/i18n-js/instance";

import { FIND_ONLINE_FORM_ID } from "./constants";
import { UnsplashPanel } from "./UnsplashPanel";

export interface FindOnlinePanelProps {
  copy: ModalCopy;
  insertFile: (file: File) => void;
  onClose: () => void;
  onSubmitUrl: (url: string) => void | Promise<void>;
}

export const FindOnlinePanel = ({
  copy,
  insertFile,
  onClose,
  onSubmitUrl,
}: FindOnlinePanelProps) => {
  const [url, setUrl] = useState("");

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    event.stopPropagation();
    if (!url) return;
    onClose();
    await onSubmitUrl(url);
  };

  return (
    <div className="flex flex-col gap-4">
      <form id={FIND_ONLINE_FORM_ID} onSubmit={onSubmit}>
        <div className="flex items-end gap-2">
          <div className="grow">
            <TextInput
              label={t("trix_editor.modal_copy.embed_link")}
              value={url}
              placeholder={copy.embedPlaceholder}
              onChange={event => setUrl(event.target.value)}
            />
          </div>
          <Button type="submit" variant="secondary" disabled={!url}>
            {t("trix_editor.modal_copy.embed")}
          </Button>
        </div>
      </form>
      <Divider />
      <UnsplashPanel insertFile={insertFile} onClose={onClose} />
    </div>
  );
};
